var $8045cf930ef745aa$exports = {};
$8045cf930ef745aa$exports = {
    "colorInputLabel": (args)=>`${args.label}, ${args.channelLabel}`,
    "colorNameAndValue": (args)=>`${args.name}: ${args.value}`,
    "colorPicker": `Renk Se\xe7ici`,
    "colorSwatch": `renk \xf6rne\u{11F}i`,
    "transparent": `saydam`,
    "twoDimensionalSlider": `2D s\xfcrg\xfc`
};


export {$8045cf930ef745aa$exports as default};
//# sourceMappingURL=tr-TR.module.js.map
